export class BaseModel {
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date;
    updatedBy?: string;
    deletedDate?: Date;
    deletedBy?: string;
    deleted?: boolean;
}
